import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import KubitTooltip from '../KubitTooltip';

interface IProps {
  isEnabled: boolean;
  reason: string;
}

const DisabledElementsPopupWrapper = styled.div`
  max-width: 200px;
`;

const DisabledElementsContentsWrapper = styled.div`
  opacity: 0.3;
`;

const DisabledElementsWrapper = ({
  children,
  isEnabled,
  reason,
}: PropsWithChildren<IProps>) => {
  if (isEnabled) {
    return <>{children}</>;
  }
  return (
    <KubitTooltip
      content={
        <DisabledElementsPopupWrapper>{reason}</DisabledElementsPopupWrapper>
      }
    >
      <DisabledElementsContentsWrapper>
        {children}
      </DisabledElementsContentsWrapper>
    </KubitTooltip>
  );
};

export default DisabledElementsWrapper;
